import { apiClient } from '../../shared/api/apiClient';
import { uploadFile } from '../../shared/api/uploadFile';
import { ContactResponseSchema } from './schemas';

export const settingsApi = {
    updateSpace: (spaceId, payload) => apiClient.put(`/api/space/${spaceId}`, payload),
    uploadSpaceIcon: (file) => uploadFile(file, 'space_icon'),

    fetchTeamMembers: async (spaceId) => {
        const json = await apiClient.get(`/api/space/${spaceId}/members`);
        if (!json.success) return [];
        return json.members.sort((a, b) => {
            const roleA = (a.role || '').toLowerCase();
            const roleB = (b.role || '').toLowerCase();
            if (roleA === 'admin') return -1;
            if (roleB === 'admin') return 1;
            return 0;
        });
    },
    inviteTeamMember: (spaceId, { email, name }) =>
        apiClient.post(`/api/space/${spaceId}/invite`, { email, name }),
    updateMemberRole: (spaceId, userId, role) =>
        apiClient.put(`/api/space/${spaceId}/members/${userId}/role`, { role }),
    updateMemberPermissions: (spaceId, userId, permissions) =>
        apiClient.put(`/api/space/${spaceId}/members/${userId}/permissions`, { permissions }),

    // 02.7-settings.md paso a/§4 -- `UserProfilePanel.jsx`'s CRM contact lookup. Nada más en el
    // frontend consumía `/api/contacts` todavía (confirmado por `/refine-plans`'s downstream
    // pass), así que esto queda en `settings` en vez de `client` -- no hay unificación forzada
    // como sí la hay para WhatsApp (§0.1).
    fetchContactByPhone: (phone) => apiClient.get(`/api/contacts/by-phone/${encodeURIComponent(phone)}`).then((d) => ContactResponseSchema.parse(d)),
    updateContactByPhone: (phone, payload) => apiClient.put(`/api/contacts/by-phone/${encodeURIComponent(phone)}`, payload).then((d) => ContactResponseSchema.parse(d)),
};
